import { render, staticRenderFns } from "./kawalanpenerbitan.vue?vue&type=template&id=7ab1c2d6&scoped=true"
import script from "./kawalanpenerbitan.vue?vue&type=script&lang=js"
export * from "./kawalanpenerbitan.vue?vue&type=script&lang=js"
import style0 from "./kawalanpenerbitan.vue?vue&type=style&index=0&id=7ab1c2d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab1c2d6",
  null
  
)

export default component.exports